import * as React from 'react';

export interface LoaderProps {
  style?: 'light' | 'dark';
}

export default ({ style = 'light' }: LoaderProps) => (
  <div className="ma4 relative">
    <div className={`loader loader-${style}`}>Loading…</div>
  </div>
);
